module.exports = __webpack_public_path__ + "media/images/glyphs/billboard-34af24367df45e9e2f318b52fef50f20.svg";